export type ScheduledBusStop = { id: string; label: string };

export type ScheduledBusDirection = {
  id: string;
  label: string;
  stops: ScheduledBusStop[];
};

export type ScheduledBusRoute = {
  id: string;
  label: string;
  directions: ScheduledBusDirection[];
};

export const ROUTES: ScheduledBusRoute[] = [
  {
    id: 'rapidride-e-line',
    label: 'RapidRide E Line',
    directions: [
      {
        id: 'northbound',
        label: 'Northbound',
        stops: [
          { id: 'stop-1610', label: 'Prefontaine Pl S & Yesler Way' },
          { id: 'stop-75409', label: 'Aurora Ave N & N 46th St' },
        ],
      },
      {
        id: 'southbound',
        label: 'Southbound',
        stops: [
          { id: 'stop-16100', label: 'Aurora Village Transit Center · Bay 10' },
          { id: 'stop-75408', label: 'Aurora Ave N & N 46th St' },
        ],
      },
    ],
  },
  {
    id: 'route-44',
    label: 'Route 44',
    directions: [
      {
        id: 'eastbound',
        label: 'Eastbound',
        stops: [
          { id: 'stop-18120', label: 'NW Market St & Ballard Ave NW' },
          { id: 'stop-29231', label: 'N 45th St & Stone Way N' },
        ],
      },
      {
        id: 'westbound',
        label: 'Westbound',
        stops: [
          { id: 'stop-9587', label: 'U District Station · Bay 1' },
          { id: 'stop-29540', label: 'N 45th St & Stone Way N' },
        ],
      },
    ],
  },
];
